import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { BaseOperateView, BaseStagePlugin, useActiveOriginIndex, useFramework, useLayerTranslate } from '@/framework';
import { ILayerProps } from '@/version-types';
import { RealEdit } from '..';
import { ICollaboratorInfo } from '../types';

/**
 * 渲染编辑图层
 */
export const RenderEditLayer: React.FC = React.memo(() => {
    const [pickInfos, setPickInfos] = useState<ICollaboratorInfo[]>([]);
    const framework = useFramework();
    const realEdit = framework.getInstance(RealEdit);
    const activeOriginIndex = useActiveOriginIndex();
    const [activeData, setActiveData] = useState<{
        layer: ILayerProps | null;
        pickLayer: ILayerProps | null;
    } | null>(null);

    /** 监听用户选中图层 */
    useEffect(() => {
        const handler = realEdit.room.onUserPick((info: ICollaboratorInfo[]) => {
            // console.log('ot RenderEditLayer 1', info);
            setPickInfos(info);
        });
        return () => {
            framework.events.off(handler);
        };
    }, []);

    /** 监听激活图层数据更新 */
    useEffect(() => {
        const handler = framework.events.onActiveLayerDataUpdate((layer, pickLayer) => {
            // console.log('ot RenderEditLayer 2', { layer, pickLayer });
            setActiveData({ layer, pickLayer });
        });
        return () => {
            framework.events.off(handler);
        };
    }, []);

    if (!pickInfos.length) return null;

    // 过滤
    // 1. 激活图层重合
    // 2. 不存在的图层
    const finalPickInfos = pickInfos.filter((item) => {
        const layerId = item.pickId || item.activeId || '';
        return (
            layerId !== activeData?.layer?.id && layerId !== activeData?.pickLayer?.id && framework.getLayer(layerId)
        );
    });
    // console.log('ot RenderEditLayer', finalPickInfos);

    return (
        <>
            {finalPickInfos.map((item) => {
                const layerId = item.pickId || item.activeId || '';
                const needRender = activeOriginIndex === framework.tryGetLayerOriginIndex(layerId);
                return (
                    <PickLayer
                        key={item.wsKey}
                        realEdit={realEdit}
                        needRender={needRender}
                        layerId={layerId}
                        color={item.color}
                    />
                );
            })}
        </>
    );
});

const PickLayer: React.FC<{
    layerId: string;
    color: string;
    needRender: boolean;
    realEdit: RealEdit;
}> = React.memo(({ color, layerId, needRender, realEdit }) => {
    const [layer, setLayer] = useState<ILayerProps | null>(null);
    const framework = useFramework();
    const refNode = useLayerTranslate(layerId);
    // console.log('ot PickLayer 3', framework.getLayer(layerId));

    /** 监听图层变化 */
    useEffect(() => {
        // console.log('ot PickLayer 2', framework.getLayer(layerId));
        setLayer(framework.getLayer(layerId));
        const handler = framework.events.onLayerChange(() => {
            // console.log('ot PickLayer 1', framework.getLayer(layerId));
            setLayer(framework.getLayer(layerId));
            // console.log('ot useLayerTransform 2');
        }, layerId);
        // const receiveDiffInfoHandler = realEdit.room.onUpdateUserPick((id) => {
        //     if (id === layerId) {
        //         // console.log('ot useLayerTransform 4');
        //         setLayer(framework.getLayer(layerId));
        //     }
        // });
        return () => {
            framework.events.off(handler);
            // framework.events.off(receiveDiffInfoHandler);
        };
    }, [layerId]);

    if (!layer || !needRender) return null;
    // console.log('ot render edit layer', layerId);

    return (
        <BaseStagePlugin originIndexOrLayerId={layerId} name="ot-edit-layer">
            <BaseOperateView ref={refNode} layer={layer}>
                <div
                    className={classNames('real-edit__edit-layer', { 'is-group': framework.checkIsGroup(layer) })}
                    style={{ borderColor: color }}
                ></div>
            </BaseOperateView>
        </BaseStagePlugin>
    );
});
